/**
 * Klivlo Christmas Projection Lamp - page behaviour (prefix lpn-).
 *
 * Loaded as type="module" so it can import this theme's own
 * `@shopify/events` and tell the native header cart icon about changes
 * (04-traps.md D8: the theme's cart components only react to a real
 * CartLinesUpdateEvent). A module runs once per URL, so no init guard.
 *
 * Offer shape: the 3 "Offre" values are real product variants (1/2/3
 * lampes), each with its own price + compare-at, so every figure on the
 * page is a real Shopify price. No client-side discount maths.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

var dataEl = document.getElementById('lpn-data');
var DATA = dataEl ? JSON.parse(dataEl.textContent) : null;

function formatMoney(cents, format) {
  cents = Math.round(Number(cents) || 0);
  var fmt = format || (DATA && DATA.moneyFormat) || '€{{amount_with_comma_separator}}';
  function delimit(n, precision, thousands, decimal) {
    var fixed = (n / 100).toFixed(precision).split('.');
    var whole = fixed[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (fixed[1] ? decimal + fixed[1] : '');
  }
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
    switch (key) {
      case 'amount': return delimit(cents, 2, ',', '.');
      case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
      case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
      case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
      case 'amount_with_space_separator': return delimit(cents, 2, ' ', ',');
      default: return delimit(cents, 2, ',', '.');
    }
  });
}

function $(sel, root) { return (root || document).querySelector(sel); }
function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

/* ---------------- Gallery ---------------- */

$$('[data-lpn-thumb]').forEach(function (thumb) {
  thumb.addEventListener('click', function () {
    var i = thumb.getAttribute('data-lpn-thumb');
    $$('[data-lpn-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    $$('.lpn-stage .lpn-slide').forEach(function (img, n) { img.classList.toggle('is-active', String(n) === i); });
  });
});

/* ---------------- FAQ: first item open by default (native <details>) ---------------- */
/* No JS needed - the first <details open> in the markup handles it. */

if (DATA) initBuy();

function initBuy() {
  var variants = DATA.variants;
  var byId = {};
  variants.forEach(function (v) { byId[v.id] = v; });

  var state = { variant: byId[DATA.defaultVariant] || variants[0], added: false };

  /* ---------- Bundle selection ---------- */

  $$('[data-lpn-pack]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = byId[b.getAttribute('data-lpn-pack')];
      if (v) { state.variant = v; render(); }
    });
  });

  function render() {
    $$('[data-lpn-pack]').forEach(function (b) {
      var on = Number(b.getAttribute('data-lpn-pack')) === state.variant.id;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var addLabel = state.added ? DATA.text.added : DATA.text.addToCart;
    $$('[data-lpn-add-label]').forEach(function (el) { el.textContent = addLabel; });
    $$('[data-lpn-sticky-price]').forEach(function (el) { el.textContent = formatMoney(state.variant.price); });
    $$('[data-lpn-sticky-compare]').forEach(function (el) {
      if (state.variant.compare > state.variant.price) { el.textContent = formatMoney(state.variant.compare); el.hidden = false; }
      else { el.hidden = true; }
    });
  }
  render();

  /* ---------- Add to cart (stays on page, opens drawer) ---------- */

  function addToCart(variant, opts) {
    opts = opts || {};
    var buttons = $$('[data-lpn-add], [data-lpn-buy]');
    buttons.forEach(function (b) { b.disabled = true; });

    var deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variant.id, quantity: 1 }],
      promise: deferred.promise,
    }));

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'Add to cart failed');
          return body;
        });
      })
      .then(fetchCart)
      .then(function (cart) {
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { didError: false, items: cart.items, source: 'lpn-buy-box' },
        });
        resetReserveDeadline();
        if (opts.redirect) {
          window.location.href = '/checkout';
          return cart;
        }
        state.added = true;
        render();
        clearTimeout(state.flashTimer);
        state.flashTimer = setTimeout(function () { state.added = false; render(); }, 1800);
        drawCart(cart);
        openDrawer(true);
        return cart;
      })
      .catch(function (err) {
        console.error('[lpn] add to cart failed', err);
        deferred.reject(err);
        alert(err.message || 'Une erreur est survenue. Merci de réessayer.');
      })
      .finally(function () {
        buttons.forEach(function (b) { b.disabled = false; });
      });
  }

  $$('[data-lpn-add]').forEach(function (b) {
    b.addEventListener('click', function () { addToCart(state.variant, { redirect: false }); });
  });
  $$('[data-lpn-buy]').forEach(function (b) {
    b.addEventListener('click', function () { addToCart(state.variant, { redirect: true }); });
  });
  $$('[data-lpn-buy-variant]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = byId[b.getAttribute('data-lpn-buy-variant')] || variants[0];
      addToCart(v, { redirect: false });
    });
  });

  /* ---------- Mobile sticky bar ---------- */

  var sticky = $('[data-lpn-sticky]');
  var buyBox = $('[data-lpn-buybox]');
  if (sticky && buyBox) {
    var drawerEl = $('[data-lpn-drawer]');
    function updateStickyVisibility() {
      if (window.innerWidth >= 900) { sticky.classList.remove('is-visible'); return; }
      if (drawerEl && !drawerEl.hidden) { sticky.classList.remove('is-visible'); return; }
      var scrolled = window.scrollY > 700;
      sticky.classList.toggle('is-visible', scrolled);
    }
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
    updateStickyVisibility();
  }

  /* ---------- Cart drawer (real cart) ---------- */

  var drawer = $('[data-lpn-drawer]');
  if (!drawer) return;
  var linesEl = $('[data-lpn-lines]', drawer);
  var lineTpl = $('[data-lpn-line-tpl]', drawer);

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function openDrawer(open) {
    drawer.hidden = !open;
    document.documentElement.classList.toggle('lpn-lock', open);
    if (open) { tick(); $('[data-lpn-close]', drawer).focus({ preventScroll: true }); }
  }

  function drawCart(cart) {
    var has = cart.item_count > 0;
    $$('[data-lpn-count]', drawer).forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-lpn-when-items]', drawer).forEach(function (el) { el.hidden = !has; });
    $('[data-lpn-empty]', drawer).hidden = has;
    $('[data-lpn-total]', drawer).textContent = formatMoney(cart.total_price, cart.money_format);

    linesEl.innerHTML = '';
    cart.items.forEach(function (item) {
      var node = lineTpl.content.firstElementChild.cloneNode(true);
      var img = $('img', node);
      if (item.image) {
        img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=168';
        img.alt = item.product_title;
      } else {
        img.remove();
      }
      $('[data-f="name"]', node).textContent = item.product_title;
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      $('[data-f="meta"]', node).textContent = variantTitle;
      var v = byId[item.variant_id];
      var saveEl = $('[data-f="save"]', node);
      if (v && v.compare > item.final_price) {
        var pct = Math.round((v.compare - item.final_price) * 100 / v.compare);
        saveEl.textContent = 'Économisez ' + pct + ' %';
      } else {
        saveEl.remove();
      }
      $('[data-f="total"]', node).textContent = formatMoney(item.final_line_price);
      var was = $('[data-f="was"]', node);
      if (v && v.compare > item.final_price) {
        was.textContent = formatMoney(v.compare * item.quantity);
      } else {
        was.remove();
      }
      $('[data-lpn-remove]', node).addEventListener('click', function () { changeLine(item.key, 0); });
      linesEl.appendChild(node);
    });
  }

  function changeLine(key, quantity) {
    drawer.classList.add('is-busy');
    var deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: quantity === 0 ? 'remove' : 'update',
      context: 'cart',
      lines: [{ id: key, quantity: quantity }],
      promise: deferred.promise,
    }));
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false } });
        drawCart(cart);
        if (cart.item_count === 0) { clearReserveDeadline(); }
      })
      .catch(function (err) { deferred.reject(err); console.error('[lpn] cart change failed', err); })
      .finally(function () { drawer.classList.remove('is-busy'); });
  }

  $$('[data-lpn-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { openDrawer(false); } ); });
  drawer.querySelector('.lpn-overlay').addEventListener('click', function () { openDrawer(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) openDrawer(false); });

  // On this page the header cart button opens this drawer instead of the
  // theme's own - one cart UI per page, not two. Capture phase so it runs
  // before the theme's delegated on:click handler.
  window.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"], a[href$="/cart"]');
    if (!trigger || drawer.contains(trigger)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetchCart().then(function (cart) { drawCart(cart); openDrawer(true); });
  }, true);

  /* ---------- Reservation countdown (cosmetic, cart drawer) ----------
     Deadline stored as a timestamp, not a decrementing counter, so it
     survives re-renders and page loads. An expired or absurd stored value
     restarts the window instead of freezing on 0:00 (04-traps.md C5).
     Starts on first add, does not restart on further adds, and clears
     when the cart becomes empty. */

  var RKEY = 'lpn-cart-deadline';
  var RWINDOW_MS = DATA.reserveMinutes * 60 * 1000;
  function readReserveDeadline() {
    var until = 0;
    try { until = Number(localStorage.getItem(RKEY)); } catch (e) {}
    return until;
  }
  function resetReserveDeadline() {
    var existing = readReserveDeadline();
    var now = Date.now();
    if (existing && !isNaN(existing) && existing > now) return existing;
    var until = now + RWINDOW_MS;
    try { localStorage.setItem(RKEY, String(until)); } catch (e) {}
    return until;
  }
  function clearReserveDeadline() {
    try { localStorage.removeItem(RKEY); } catch (e) {}
  }
  function tick() {
    var until = readReserveDeadline();
    var left = until ? Math.max(0, Math.round((until - Date.now()) / 1000)) : DATA.reserveMinutes * 60;
    var label = Math.floor(left / 60) + ':' + String(left % 60).padStart(2, '0');
    $$('[data-lpn-reserve-timer]', drawer).forEach(function (el) { el.textContent = label; });
  }
  setInterval(function () { if (!drawer.hidden) tick(); }, 1000);
  if (fetchCart) {
    fetchCart().then(function (cart) { if (cart.item_count > 0) { drawCart(cart); } });
  }
}

/* ---------- Sale countdown (announcement bar + urgency box) ----------
   Real, merchant-set end date - not a looping fake timer (French law,
   see the handoff README). Both displays share one deadline. Hidden
   once the deadline has passed. */

(function () {
  var nodes = $$('[data-lpn-sale-timer]');
  if (!nodes.length) return;
  var endIso = nodes[0].getAttribute('data-lpn-sale-end');
  var end = endIso ? new Date(endIso).getTime() : NaN;
  if (!end || isNaN(end)) {
    $$('[data-lpn-sale-wrap]').forEach(function (el) { el.hidden = true; });
    return;
  }
  function tick() {
    var left = Math.round((end - Date.now()) / 1000);
    if (left <= 0) {
      $$('[data-lpn-sale-wrap]').forEach(function (el) { el.hidden = true; });
      clearInterval(timer);
      return;
    }
    var h = Math.floor(left / 3600);
    var m = Math.floor((left % 3600) / 60);
    var s = left % 60;
    var label = String(h).padStart(2, '0') + 'h ' + String(m).padStart(2, '0') + 'm ' + String(s).padStart(2, '0') + 's';
    nodes.forEach(function (el) { el.textContent = label; });
  }
  tick();
  var timer = setInterval(tick, 1000);
})();
